import { Vector as VectorLayer } from "ol/layer.js";
import { Vector as VectorSource } from "ol/source.js";
import WKT from "ol/format/WKT.js";

import { points as pointsService } from "../../services/index.js";
import { style } from "./index.js";

export default {
  addMeasureLayer(map) {
    const source = new VectorSource();

    const vector = new VectorLayer({
      source: source,
      style: style.getMeasureStyle()
    });

    map.addLayer(vector);

    return vector;
  },

  /**
   * Load the points layer
   *
   * @param {ol.Map} map
   */
  loadPointsLayer(map) {
    let pointsLayer = null;

    map.getLayers().forEach(layer => {
      if (layer.get("title") === "points") {
        pointsLayer = layer;
      }
    });

    return pointsService.getPoints().then(data => {
      const wkt = new WKT();

      if (!pointsLayer) {
        pointsLayer = new VectorLayer({
          title: "points",
          source: new VectorSource(),
          style: style.getPointsStyle
        });

        map.addLayer(pointsLayer);
      }
      pointsLayer.getSource().clear();

      data.data.forEach(function(item) {
        const feature = wkt.readFeature(item.geom, {
          // dataProjection: "EPSG:3787",
          featureProjection: "EPSG:3857"
        });

        feature.set("rotation", item.angle);
        feature.set("size", item.size);
        feature.set("label", item.label);
        feature.set("gid", item.gid);
        feature.set("color", item.color);

        pointsLayer.getSource().addFeature(feature);
      });

      return pointsLayer;
    });
  },

  /**
   * Reload the main Mapserver layer
   *
   * @param {ol.Map} map
   */
  reloadMainLayer(map) {
    let mainLayer = null;

    map.getLayers().forEach(layer => {
      if (layer.get("name") === "GeoPro") {
        mainLayer = layer;
      }
    });

    if (!mainLayer) {
      console.log("Main layer not found");
      return;
    }

    mainLayer.getSource().refresh();
  },

  getOrCreateLayer(name, options) {
    const map = options.map;
    const clear = options.clear || false;

    const layer = map
      .getLayers()
      .getArray()
      .find(l => l.get("title") === name);

    if (layer) {
      if (clear) {
        layer.getSource().clear();
      }

      return layer;
    }

    const newLayer = new VectorLayer({
      title: name,
      source: new VectorSource(),
      style: style.getDrawParcelStyle,
      zIndex: 200
    });

    map.addLayer(newLayer);

    return newLayer;
  }
};
